import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IUser } from 'src/app/data-types/user-data';
import { VoiceContactData } from 'src/app/data-types/voice-data';
import { AlertConfirmable } from 'src/app/decorators/alert-confirmable.decorator';
import { AlertService } from 'src/app/services/alert.service';
import { TwilioService } from 'src/app/services/twilio.service';

@Component({
    selector: 'app-user-select-or-create',
    templateUrl: './user-select-or-create.component.html',
    styleUrls: ['./user-select-or-create.component.scss'],
})
export class UserSelectOrCreateComponent implements OnInit {
    @Input() form: FormGroup;
    @Input() selectedUser: IUser;

    constructor(public twilioService: TwilioService, private alertService: AlertService) {}

    ngOnInit(): void {
        this.extendFormControls();
    }

    customerSelected(customer) {
        const customerId = customer?.id ?? null;
        this.form.get('customerId').setValue(customerId);
        this.selectedUser = customer;
    }

    @AlertConfirmable({ title: 'Do you want to make a call?' })
    makeACallProspect() {
        const customer = this.selectedUser;
        if (!this.twilioService.isLineBusy) {
            const contact: VoiceContactData = {
                id: customer.id,
                accountType: customer.accountType,
                contactId: customer.id,
                contactFirstname: customer.firstname,
                contactSurname: customer.surname,
                contactMobile: customer.mobile,
                contactEmail: customer.email,
            } as VoiceContactData;
            this.twilioService.startOutboundCall(customer.mobile, contact.id ? contact : null);
        } else {
            this.alertService.error([
                'Line is busy, please nicely finish ongoing conversation before starting the new one.',
            ]);
        }
    }

    private extendFormControls() {
        this.form.addControl('customerId', new FormControl());
    }
}
